import 'styles/index.scss'
import { Buffer } from 'buffer/'
import { IKContext } from 'imagekitio-react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThirdwebProvider } from 'thirdweb/react'
import { WagmiConfig } from 'wagmi'
import config from 'app/configWagmi'
import constants from 'app/constants'
import PersonaProvider from 'app/services/PersonaProvider/PersonaProvider'
import RootProvider from 'app/services/RootProvider/RootProvider'
import UserProvider from 'app/services/UserProvider/UserProvider'
import WalletProvider from 'app/services/WalletProvider/WalletProvider'
import { ROOT } from 'app/thread'
import ModalProvider from 'components/interface/Modal/provider/ModalProvider'
import TooltipProvider from 'components/interface/Tooltip/provider/TooltipProvider'
import App from './App'

// Apply (for wallet connecting)
window.Buffer = Buffer

const root = createRoot(ROOT)

/**
 * Render the application container, wrapped
 * inside the 3rd party providers
 */
root.render(
  <BrowserRouter>
    <ThirdwebProvider>
      <WagmiConfig config={config}>
        <WalletProvider>
          <ModalProvider>
            <RootProvider>
              <PersonaProvider>
                <UserProvider>
                  <TooltipProvider>
                    <IKContext urlEndpoint={constants.PATH_CDN}>
                      <App />
                    </IKContext>
                  </TooltipProvider>
                </UserProvider>
              </PersonaProvider>
            </RootProvider>
          </ModalProvider>
        </WalletProvider>
      </WagmiConfig>
    </ThirdwebProvider>
  </BrowserRouter>
)